import { useMemo, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ContentCard from '../components/ContentCard';
import PageShell from '../components/PageShell';
import useSiteContent from '../hooks/useSiteContent';
import { fallbackDeals } from '../data/fallbackContent';

const { FiSearch, FiTag } = FiIcons;

export default function LTD() {
  const { data: deals } = useSiteContent('deals', fallbackDeals);
  const [query, setQuery] = useState('');
  const filtered = useMemo(
    () => deals.filter((deal) =>
      `${deal.title} ${deal.description} ${deal.category}`
        .toLowerCase()
        .includes(query.toLowerCase())
    ),
    [deals, query]
  );

  return (
    <PageShell>
      <section className="page-heading">
        <span className="page-icon"><SafeIcon icon={FiTag} /></span>
        <div>
          <p className="eyebrow">Lifetime deals</p>
          <h1>Software worth a look</h1>
          <p>Curated tools for creators and small teams.</p>
        </div>
      </section>

      <label className="search-box">
        <SafeIcon icon={FiSearch} />
        <span className="sr-only">Search deals</span>
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search deals"
        />
      </label>

      <section className="link-stack" aria-label="Lifetime deals">
        {filtered.map((item, index) => (
          <ContentCard
            key={item.id}
            item={item}
            entity="deals"
            featured={index === 0}
            index={index}
          />
        ))}
      </section>
    </PageShell>
  );
}